import config from "@Config/index";
import POPULAR_COUNTRIES from "@Pages/Home/components/PopularCities/data/popularCountries";

const getShareImage = (path: string) => {
  if (path === "/") return `${config.IMAGE_STATIC_URL}/images/china-mobile-first-fold-long.png`;
  let result;
  for (const country of POPULAR_COUNTRIES) {
    for (const city of country.popular_cities) {
      if (path.includes(city.canonical_name)) {
        result = city.image.replace(
          "https://prod-static-assets.amberstudent.com",
          config.IMAGE_ASSETS_URL,
        );
        break;
      }
    }
    if (result) break;
  }
  return result;
};

export default getShareImage;
